export enum Status {
  None = 0,
  MultiPunchDisableChart = 1,
  MultiPunchEnableChart = 2
  }